import { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import SweetAlert2 from "react-sweetalert2";
import * as actions from "../redux/ReportAction";
import { useParams, useSearchParams } from "react-router-dom";
import { formatInTimeZone } from "date-fns-tz";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import DateRangeComp from "../../common/DateRangeComp";

export const AgentDownlineDetailsList = () => {
  const { selmasterid } = useParams();
  const intl = useIntl();
  const [swalProps, setSwalProps] = useState({});
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [fromDate, setFromDate] = useState(
    new Date(searchParams?.get("fromDate"))
  );
  const [toDate, setToDate] = useState(new Date(searchParams?.get("toDate")));
  const reportState = useSelector(({ report }) => report, shallowEqual);
  const timeZone = "Asia/Kuala_Lumpur";

  useEffect(() => {
    const fromDateStr = searchParams?.get("fromDate");
    const toDateStr = searchParams?.get("toDate");
    if (fromDateStr && toDateStr) {
      const fromDateParsed = new Date(fromDateStr);
      const toDateParsed = new Date(toDateStr);

      if (!isNaN(fromDateParsed) && !isNaN(toDateParsed)) {
        setFromDate(fromDateParsed);
        setToDate(toDateParsed);
        const queryParams = {
          action: "allcompanygamewinlose",
          fromdate: formatInTimeZone(fromDateParsed, timeZone, "yyyy-MM-dd"),
          todate: formatInTimeZone(toDateParsed, timeZone, "yyyy-MM-dd"),
          selmasterid: selmasterid,
        };

        dispatch(actions.agentDownlineDetails(queryParams));
      } else {
        console.error("Invalid date format received:", {
          fromDateStr,
          toDateStr,
        });
      }
    }
  }, [selmasterid, searchParams, dispatch]);

  const handleDateChange = (start, end) => {
    setFromDate(start);
    setToDate(end);
  };

  const handleSearchClick = () => {
    const queryParams = {
      action: "allcompanygamewinlose",
      fromdate: formatInTimeZone(fromDate, timeZone, "yyyy-MM-dd"),
      todate: formatInTimeZone(toDate, timeZone, "yyyy-MM-dd"),
      selmasterid: selmasterid,
    };

    dispatch(actions.agentDownlineDetails(queryParams)).then((resp) => {
      resp = resp.data;
      if (parseInt(resp.code) === ApiStatusTypeEnum.COMMON_ERROR) {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };
  return (
    <div style={{ width: "98%", margin: "5px auto" }}>
      <SweetAlert2
        customClass="custom-swal"
        onResolve={() => setSwalProps({})}
        {...swalProps}
      />
      <div className="d-flex align-items-center">
        <h2>{intl.formatMessage({ id: "agentDownlineDetails" })}</h2>
      </div>
      <div>
        <span>{searchParams?.get("currentAgent") ?? ""}</span>
      </div>
      <div className="dateSearch-div">
        <div className="dateRange-div">
          <DateRangeComp
            initialRange={[
              { startDate: fromDate, endDate: toDate, key: "selection" },
            ]}
            onDateChange={handleDateChange}
          />
        </div>
        <div>
          <button
            className="btn btn-primary"
            onClick={() => handleSearchClick()}
          >
            {intl.formatMessage({ id: "search" })}
          </button>
        </div>
      </div>

      <div className="member-div d-flex" style={{ margin: "10px auto" }}>
        <div className="member-container">
          <div className="table-responsive">
            <table className="member-table">
              <thead className="member-header1">
                <tr className="member-row1">
                  <th className="member-cell hide-on-mobile ">
                    {intl.formatMessage({ id: "no" })}
                  </th>
                  <th className="member-cell text-start text-nowrap">
                    {intl.formatMessage({ id: "companyName" })}
                  </th>
                  <th className="member-cell text-end text-nowrap">
                    {intl.formatMessage({ id: "promotion" })}
                  </th>
                  <th className="member-cell text-end text-nowrap">
                    {intl.formatMessage({ id: "gameIn" })}
                  </th>
                  <th className="member-cell text-end text-nowrap">
                    {intl.formatMessage({ id: "gameOut" })}
                  </th>
                  <th className="member-cell text-end text-nowrap">
                    {intl.formatMessage({ id: "gameProfit" })}
                  </th>
                  <th className="member-cell text-end text-nowrap">
                    {intl.formatMessage({ id: "progressiveBet" })}
                  </th>
                  <th className="member-cell text-end text-nowrap">
                    {intl.formatMessage({ id: "progressiveWin" })}
                  </th>
                </tr>
              </thead>
              <tbody className="member-body">
                {reportState.agentDownlineDetailsLists
                  ?.allCompanyGameWinLoses &&
                  reportState.agentDownlineDetailsLists.allCompanyGameWinLoses
                    .length > 0 &&
                  reportState.agentDownlineDetailsLists.allCompanyGameWinLoses.map(
                    (report, index) => (
                      <tr key={index} className="member-row1">
                        <td className="member-cell hide-on-mobile ">
                          {index + 1}
                        </td>
                        <td className="member-cell text-start">
                          {report.companyname}
                        </td>
                        <td className="member-cell text-end">
                          {report.promoin}
                        </td>
                        <td className="member-cell text-end">
                          {report.gamein}
                        </td>
                        <td className="member-cell text-end">
                          {report.gameout}
                        </td>
                        <td
                          className="member-cell text-end"
                          style={{
                            color: report.gameprofit?.includes("-")
                              ? "red"
                              : "green",
                          }}
                        >
                          {report.gameprofit}
                        </td>
                        <td className="member-cell text-end">
                          {report.progressivebet}
                        </td>
                        <td className="member-cell text-end">
                          {report.progressivewin}
                        </td>
                      </tr>
                    )
                  )}
              </tbody>
              <tfoot>
                {reportState && reportState.agentDownlineDetailsLists && (
                  <tr className="member-row1">
                    <td className="member-cell hide-on-mobile "></td>
                    <td className="member-cell text-end">
                      {intl.formatMessage({ id: "total" }) + " : "}
                    </td>
                    <td className="member-cell text-end">
                      {reportState.agentDownlineDetailsLists.totalpromoin}
                    </td>
                    <td className="member-cell text-end">
                      {reportState.agentDownlineDetailsLists.totalgamein}
                    </td>
                    <td className="member-cell text-end">
                      {reportState.agentDownlineDetailsLists.totalgameout}
                    </td>
                    <td
                      className="member-cell text-end"
                      style={{
                        color:
                          reportState.agentDownlineDetailsLists.totalgameprofit?.includes(
                            "-"
                          )
                            ? "red"
                            : "green",
                      }}
                    >
                      {reportState.agentDownlineDetailsLists.totalgameprofit}
                    </td>
                    <td className="member-cell text-end">
                      {
                        reportState.agentDownlineDetailsLists
                          .totalprogressivebet
                      }
                    </td>
                    <td className="member-cell text-end">
                      {
                        reportState.agentDownlineDetailsLists
                          .totalprogressivewin
                      }
                    </td>
                  </tr>
                )}
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
